<template>
  <div class="terms-of-services-page">
    <page-cover :cover="cover" v-if="cover" />
    <TermsOfServices />
  </div>
</template>

<script>
import PageCover from "@/components/shared/PageCover.vue";
import TermsOfServices from "@/components/terms-of-services/TermsOfServices.vue";
import { mapGetters } from "vuex";

export default {
  name: "termsOfServices",
  computed: {
    ...mapGetters({
      cover: "pageCover/getTermsOfServices", // <-- using the new getter
    }),
  },
  components: {
    PageCover,
    TermsOfServices,
  },
};
</script>
